import apiHelpers from './apiHelpers';

export default {
    getStats({ begin, end, bundleId, sort, order, page, perPage }) {
        let url = `consumption/stats?begin=${begin}&end=${end}&page=${page}&per_page=${perPage}&sort=${sort}&order=${order}`;
        if (bundleId) {
            url += `&bundle_id=${bundleId}`;
        }
        return apiHelpers.httpRequest(url, {}, 'get');
    },
    getHeatmap({ begin, end, policyLabel, groupBy, bundleId, geo, productId, payType }) {
        const params = new URLSearchParams({ begin, end, policy_label: policyLabel });
        if (groupBy && groupBy.length) params.set('group_by', groupBy.join(','));
        if (bundleId) params.set('bundle_id', bundleId);
        if (geo) params.set('geo', geo);
        if (productId) params.set('product_id', productId);
        if (payType) params.set('pay_type', payType);
        return apiHelpers.httpRequest(`consumption/heatmap?${params.toString()}`, {}, 'get');
    },
    getLabels({ begin, end }) {
        return apiHelpers.httpRequest(`consumption/labels?begin=${begin}&end=${end}`, {}, 'get');
    },
};
